/* eslint-disable no-nested-ternary */
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useInjectSaga} from 'utils/injectSaga';
import teamSaga from 'sagas/teamSaga';
import {getTeamMembers, switchOrder} from 'actions/teamActions';
import {updateUser} from 'actions/userActions';
import {ReactComponent as InsertBelow} from 'assets/svgs/actions/add-member.svg';
import {ReactComponent as MoveUp} from 'assets/svgs/categories/contextmenu/up.svg';
import {ReactComponent as MoveDown} from 'assets/svgs/categories/contextmenu/down.svg';
import {Item, Menu, useContextMenu} from 'react-contexify';
import useScrollable from 'hooks/useScrollable';

import Row from './Row';
import Filters from './Filters';
import './style.scss';
import 'react-contexify/dist/ReactContexify.css';

// eslint-disable-next-line import/order
import {fetchRoles} from 'actions/rolesAction';
import rolesSaga from '../../../sagas/rolesSaga';

const Team = () => {
  useInjectSaga({key: 'team', saga: teamSaga});
  useInjectSaga({key: 'role', saga: rolesSaga});
  const table = useRef();
  useScrollable(table);
  const [addTeam, setAddTeam] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [members, setMembers] = useState([]);
  const [allMembers, setAllMembers] = useState([]);
  const teams = useSelector((state) => state.team.teams);
  const roles = useSelector((state) => state.roles.roles);
  const [uniqueId, setUniqueId] = useState(0);
  const [contextData, setContextData] = useState(null);
  const dispatch = useDispatch();
  const {show} = useContextMenu({
    id: 'CATEGORY_POST',
  });

  useEffect(() => {
    dispatch(getTeamMembers());
    dispatch(fetchRoles());
  }, []);

  const formatUsers = () => {
    const data = teams.reduce((list, current) => {
      if (current.users.length > 0) {
        const users = current.users.map((u) => {
          const rs = roles.filter((r) => u.roles.includes(r._id));
          const a = teams.find((t) => t._id === u.teamId);
          let teamName = '';
          if (a) teamName = a.name;
          return {...u, name: current.name, roles: rs, teamName};
        });
        list = [...list, ...users];
      }
      return list;
    }, []);
    return data.sort((a, b) => a.teamOrder - b.teamOrder);
  };
  const onFilter = (filters) => {
    let mems = formatUsers();

    if (filters.searchKey) {
      const key = filters.searchKey.toLowerCase();
      mems = mems.filter(
        (m) =>
          m.teamId.name.toLowerCase().indexOf(key) > -1 ||
          m.firstName.toLowerCase().indexOf(key) > -1
      );
    }

    if (filters.role) {
      mems = mems.filter((m) =>
        m.roles.find((r) => r._id === filters.role._id)
      );
    }
    if (filters.team) {
      mems = mems.filter((m) => m.teamId._id === filters.team._id);
    }
    if (filters.manager) {
      mems = mems.filter((m) => m._id === filters.manager);
    }
    setMembers(mems);
  };

  useEffect(() => {
    if (teams.length > 0 && roles.length > 0) {
      const mems = formatUsers();
      setMembers(mems);
      setAllMembers(mems);
    }
  }, [teams, roles]);

  useEffect(() => {
    const ids = members.map((m) => parseInt(m.uniqueId, 10));
    const maxId = Math.max(...ids);

    if (ids.length > 0) {
      setUniqueId(maxId + 1);
    }
  }, [members]);

  const handleContextMenu = (event, data) => {
    setContextData(data);
    show(event);
  };

  const insert = (arr, index, newItem) => [
    ...arr.slice(0, index),
    newItem,
    ...arr.slice(index),
  ];

  const SingleContextMenu = () => (
    <Menu
      id="CATEGORY_POST"
      animation={null}
      onHidden={() => {
        setContextData(null);
      }}
    >
      <>
        <Item
          onClick={() => {
            const user = {
              password: '',
              firstName: '',
              lastName: '',
              email: '',
              memberType: 'MEMBER',
              isActive: true,
              roles: [],
              avatar: undefined,
              teamName: '',
              userId: undefined,
              uniqueId,
              teamOrder: contextData.index + 2,
              _id: 'new_user',
            };
            setSelectedTeam(user);
            const newMembers = insert(
              [...members].filter((f) => f._id !== 'new_user'),
              contextData.index + 1,
              user
            );
            setMembers(newMembers);
            setAddTeam('new_user');
          }}
        >
          <InsertBelow className="mr-2" />
          Add new member
        </Item>
        <Item
          disabled={contextData && contextData.index === 0}
          onClick={() => {
            const first = {
              ...members[contextData.index - 1],
            };
            const current = {...contextData, teamOrder: first.teamOrder};
            first.teamOrder = contextData.teamOrder;
            dispatch(
              switchOrder([
                {_id: first._id, teamOrder: first.teamOrder},
                {
                  _id: current._id,
                  teamOrder: current.teamOrder,
                },
              ])
            );
            setTimeout(() => {
              dispatch(getTeamMembers());
            });
          }}
        >
          <MoveDown className="mr-2" />
          Move Up
        </Item>
        <Item
          disabled={contextData && contextData.index + 1 === members.length}
          onClick={() => {
            const first = {
              ...members[contextData.index],
            };
            const second = {...contextData, teamOrder: first.teamOrder};
            first.teamOrder = contextData.teamOrder;
            dispatch(
              switchOrder([
                {_id: first._id, teamOrder: first.teamOrder},
                {
                  _id: second._id,
                  teamOrder: second.teamOrder,
                },
              ])
            );
            setTimeout(() => {
              dispatch(getTeamMembers());
            });
          }}
        >
          <MoveUp className="mr-2" />
          Move Down
        </Item>
      </>
    </Menu>
  );
  let managers = [];
  if (allMembers && roles) {
    managers = allMembers.filter((f) => {
      if (f._id === 'new_user') return false;
      return f.roles.find((r) => r.title === 'manager');
    });
  }

  return (
    <div className="dashboard-list">
      <Filters
        teams={teams}
        // managers={allMembers.filter(
        //   f => f._id !== 'new_user' && f.masterRoleId.title.indexOf('manager') > -1,
        //  )}
        managers={managers}
        roles={roles}
        onChange={(filters) => {
          onFilter(filters);
        }}
      />
      <div className="table-responsive team-dasbo-list mt-4" ref={table}>
        <table className="table table-bordered text-center mb-0" id="cat-table">
          <thead>
            <tr className="bg-light-gray">
              <th
                className="bg-light-gray"
                style={{minWidth: 80, maxWidth: 80}}
              >
                ID
              </th>
              <th className="bg-light-gray" style={{minWidth: 80}}>
                TEAM
              </th>
              <th className="bg-light-gray" style={{minWidth: 255}}>
                MEMBER
              </th>
              <th className="bg-light-gray" style={{minWidth: 255}}>
                EMAIL
              </th>
              <th className="bg-light-gray" style={{minWidth: 142}}>
                JOIN
              </th>
              <th className="bg-light-gray" style={{minWidth: 200}}>
                ROLE
              </th>
              <th className="bg-light-gray" style={{minWidth: 140}}>
                POST
              </th>
              <th className="bg-light-gray" style={{minWidth: 130}}>
                LAST LOGIN
              </th>
              <th className="bg-light-gray" style={{minWidth: 180}}>
                STATUS
              </th>
            </tr>
          </thead>
          <tbody>
            {members.map((member, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={i}>
                <Row
                  selectedTeam={selectedTeam}
                  member={member}
                  handleContextMenu={handleContextMenu}
                  setSelectedTeam={setSelectedTeam}
                  setAddTeam={setAddTeam}
                  addTeam={addTeam}
                  index={i}
                  roles={member.roles}
                  onClear={() => {
                    const newMembers = [...members].filter(
                      (f) => f._id !== 'new_user'
                    );
                    setMembers(newMembers);
                  }}
                  onUpdated={(updated) => {
                    const newMembers = updated.isDeleted
                      ? [...members].filter((f) => f._id !== updated._id)
                      : [...members].map((m) =>
                          m._id === updated._id ? updated : m
                        );
                    setMembers(newMembers);
                  }}
                  updateBelow={() => {
                    const toUpdate = members
                      .filter((f, index) => index > i)
                      .map((m) => ({
                        _id: m._id,
                        teamOrder: m.teamOrder + 2,
                      }));
                    dispatch(switchOrder(toUpdate));
                    setSelectedTeam(null);
                    setAddTeam(null);
                    dispatch(getTeamMembers());
                  }}
                  updateUser={() => {
                    dispatch(
                      updateUser(member._id, {
                        _id: member._id,
                        isActive: !member.isActive,
                      })
                    );

                    setTimeout(() => {
                      dispatch(getTeamMembers());
                    }, 1000);
                  }}
                  uniqueId={uniqueId}
                />
              </React.Fragment>
            ))}

            <tr className="bg-light-gray empty-row">
              <td colSpan="10"></td>
            </tr>
          </tbody>
        </table>
      </div>
      {SingleContextMenu()}
    </div>
  );
};
export default Team;
